import { ChangeDetectorRef, Component, effect, ElementRef, EventEmitter, HostListener, Input, Output, signal, SimpleChanges, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { SharedService } from 'src/app/common/services/shared.service';

@Component({
  selector: 'app-report-sub-menu',
  templateUrl: './report-sub-menu.component.html',
  styleUrls: ['./report-sub-menu.component.scss']
})
export class ReportSubMenuComponent {

  @Input() menuList: any;
  @Output() menuChangeValue = new EventEmitter();
  currentScroll: any = 0;
  @Input() activeTab: any = 0;
  @Input() activeTabName: string = '';
  @Input() isPropertyDetailPage : boolean = false;
  scrollE: ElementRef | any = null;
  isScroller = true;
  scrollEvent!: () => void;

  //Scrollbar left to right
  @ViewChild('reportTab') reportTab: ElementRef | any;
  showLeftArrow = false;
  showRightArrow = false;
  private resizeObserver: ResizeObserver | any;
  currentLang: string = '';
  constructor(private sharedService: SharedService, private cd: ChangeDetectorRef) { }
  languageSub$: Subscription = new Subscription();
  ngOnInit() {
    this.setLang();
    if (this.activeTab) {
      let menu: any = {};
      menu['name'] = this.activeTab;
      setTimeout(() => {
        // this.menuChangeValue.emit(menu);
        this.currentScroll = menu.name;
        const element = document.getElementById(this.activeTab);
        if (element) {
          element.scrollIntoView({ behavior: 'instant', block: 'start' });
        }
      })
    }
  }
  ngOnChanges(changes: SimpleChanges){
    if(this.isPropertyDetailPage && (changes['menuList'].currentValue?.length !== changes['menuList'].previousValue?.length))
      this.currentScroll = this.menuList[0].name;
  }
  ngAfterViewInit() {
    this.scrollE = document.querySelector('.report-list-data');
    let property = document.querySelector('.property-detail-scroll');
    let projectDetail = document.querySelector('.project-detail-scroll');
    if (property) {
      this.scrollE = property;
    }
    if (projectDetail && !property) {
      this.scrollE = projectDetail;
    }
    if (this.scrollE) {
      setTimeout(() => { this.scrollEvent = this.scrollE.addEventListener('scroll', this.onScroll.bind(this)) }, 1000);
    }
    //Check left & right arrow visible or not function
    this.setupResizeObserver();
  }
  setLang(): void {
    this.languageSub$ = this.sharedService.language$.subscribe(lang => {
      this.currentLang = lang;
      setTimeout(() => {
        this.checkArrows();
      }, 1000)
    })
  }
  /**
   * Resize div call this function
  */
  private setupResizeObserver() {
    this.resizeObserver = new ResizeObserver(() => this.checkArrows());
    this.resizeObserver.observe(this.reportTab.nativeElement);
  }
  /**
   * Check left & right arrow visible or not
  */
  // checkArrows() {
  //   // Define scrollRight if not already defined
  //   if (!Object.getOwnPropertyDescriptor(Element.prototype, 'scrollRight')) {
  //     Object.defineProperty(Element.prototype, 'scrollRight', {
  //       get: function () {
  //         return this.scrollWidth - this.clientWidth - this.scrollLeft;
  //       }
  //     });
  //   }
  //   // Assuming you have access to the element
  //   if (this.reportTab) {
  //     const element = this.reportTab.nativeElement;
  //     // Get the scroll values
  //     const scrollLeft = element.scrollLeft;
  //     const scrollRight = element.scrollRight; // This should now be defined
  //     const clientWidth = element.clientWidth;
  //     const scrollWidth = element.scrollWidth;
  //     // Determine which arrows to show based on the current language
  //     if (this.currentLang === 'en') {
  //       this.showLeftArrow = scrollLeft > 0;
  //       this.showRightArrow = Math.ceil(scrollLeft + clientWidth) < scrollWidth;
  //     } else {
  //       this.showLeftArrow = Math.abs(scrollLeft) + clientWidth < scrollWidth;
  //       this.showRightArrow = scrollRight + clientWidth > scrollWidth;
  //     }
  //   }
  // }

  checkArrows() {
  if (!this.reportTab) return;

  const element = this.reportTab.nativeElement;
  const scrollLeft = element.scrollLeft;
  const clientWidth = element.clientWidth;
  const scrollWidth = element.scrollWidth;

  const tolerance = 5; 
  const isRTL = this.currentLang !== 'en';

  if (isRTL) {
    // For Arabic or any RTL language
    const absLeft = Math.abs(scrollLeft);
    const remainingScroll = scrollWidth - clientWidth - absLeft;

    // Right arrow (scroll more left visually)
    this.showRightArrow = absLeft > tolerance;

    // Left arrow (scroll more right visually)
    this.showLeftArrow = remainingScroll > tolerance;
  } else {
    // For English or any LTR language
    this.showLeftArrow = scrollLeft > tolerance;
    this.showRightArrow = Math.ceil(scrollLeft + clientWidth) < scrollWidth - tolerance;
  }
}

  /**
   * Scroll To LeftSide
  */
  scrollLeft() {
    const clientWidth = this.reportTab.nativeElement.clientWidth;
    this.reportTab.nativeElement.scrollBy({ left: -(clientWidth / 3), behavior: 'smooth' });
    setTimeout(() => this.checkArrows(), 300);
  }
  /**
   * Scroll To RightSide
  */
  scrollRight() {
    const clientWidth = this.reportTab.nativeElement.clientWidth;
    this.reportTab.nativeElement.scrollBy({ left: clientWidth / 3, behavior: 'smooth' });
    setTimeout(() => this.checkArrows(), 300);
  }
trackByMenuName(index: number, item: any) {
  return item.name;
}

  onScroll(event: Event) {
    if (!this.isScroller) return;
  
    const scrollTop = (event.target as HTMLElement).scrollTop;
    const scrollHeight = (event.target as HTMLElement).scrollHeight;
    const clientHeight = (event.target as HTMLElement).clientHeight;
    const scrollBottom = scrollTop + clientHeight;
  
    let tabSections = document.querySelectorAll('.report-tabsection');
    const tabSectionsProperty = document.querySelectorAll('.report-tabsection-d');
    const projDetailTabSec = document.querySelectorAll('.proj-detail-tabsection');
  
    if (tabSectionsProperty.length) {
      tabSections = tabSectionsProperty;
    }
    if (projDetailTabSec.length && !tabSectionsProperty.length) {
      tabSections = projDetailTabSec;
    }
  
    let closestIndex = -1;
    let minDistance = Infinity;
  
    for (let i = 0; i < tabSections.length; i++) {
      const section = tabSections[i] as HTMLElement;
      const rect = section.getBoundingClientRect();
      const distance = Math.abs(rect.top);
  
      if (distance < minDistance) {
        minDistance = distance;
        closestIndex = tabSectionsProperty ? Number(section.id) : i;
      }
    }
  
    if (scrollTop === 0 && tabSections.length) {
      const firstElement = tabSections[0];
      const firstId = firstElement.id;
      this.activeTab = Number(firstId); // First tab
    } else if (scrollBottom >= scrollHeight - 1) {
      const lastElement = tabSections[tabSections.length - 1];
      const lastId = lastElement.id;
      this.activeTab = Number(lastId); // Last tab
    } else {
      this.activeTab = Number(closestIndex);
    }
    if (this.activeTabName === 'property') {
      this.sharedService.activeTab.set(this.activeTab);
    }
    setTimeout(() => {
      this.currentScroll = '';
    });
  }
  

  menuChange(menu: any, event: any) {
    this.activeTab = menu.name;
    this.currentScroll = menu.name;
    this.isScroller = false;
    setTimeout(() => {
      this.menuChangeValue.emit(menu);
      this.currentScroll = menu.name;
    }, 100)
    setTimeout(() => {
      this.isScroller = true;
      const target = event.target as HTMLElement;
      target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      setTimeout(() => this.checkArrows(), 300);
    }, 1000)
    //click to menu tab center
  }

  ngOnDestroy() {
    this.activeTabName = '';
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
    this.languageSub$.unsubscribe();
    if (this.scrollE) this.scrollE.removeEventListener('scroll', this.scrollEvent);
  }

}
